function copy() {
  var codeElem = document.getElementById("cupon-code");
  var btnElem = document.getElementById("cupon-code_button");
  var btnTextElem = btnElem.querySelector("span");
  var originalText = btnTextElem ? btnTextElem.innerText : btnElem.innerText;
  var originalBg = btnElem.style.backgroundColor;

  // 创建临时textarea以便复制
  var textarea = document.createElement("textarea");
  textarea.value = codeElem.innerText;
  document.body.appendChild(textarea);
  textarea.select();
  try {
    document.execCommand("copy");
    // 修改按钮文案和背景色
    if (btnTextElem) {
      btnTextElem.innerText = "Copied";
    } else {
      btnElem.innerText = "Copied";
    }
    btnElem.querySelector("span").style.backgroundColor = "#e6e6e6";
    // 3秒后恢复
    setTimeout(function() {
      if (btnTextElem) {
        btnTextElem.innerText = originalText;
      } else {
        btnElem.innerText = originalText;
      }
      btnElem.querySelector("span").style.backgroundColor = originalBg;
    }, 3000);
  } catch (e) {
    // 复制失败可选处理
  }
  document.body.removeChild(textarea);
}